import Modal from 'components/Modal';
import PropTypes from 'prop-types';
import React from 'react';
import SetCodeWordForm from './private/SetCodeWordForm';
import { saveCodeWord } from '../../services/API';
import errorMessages from 'constants/errorMessages';

export default class CodeWord extends React.Component {
  static propTypes = {
    showModal: PropTypes.bool.isRequired,
    onHideModal: PropTypes.func.isRequired,
  };

  state = {
    loading: false,
    error: null,
    data: null,
  };

  handleSubmit = (immutableData) => {
    const data = immutableData.toJS();
    const requestData = { codeWord: data.codeWord };
    this.setState({
      loading: true,
    });

    saveCodeWord(requestData)
      .then((response) => {
        if (!response.isOk) {
          throw response.error;
        }

        return response.data;
      })
      .then((responseData) => {
        this.setState(
          {
            data: responseData,
            loading: false,
          },
          () => {
            this.props.onHideModal();
          },
        );
      })
      .catch(() => {
        this.setState({
          error: errorMessages.defaultServerError,
          loading: false,
        });
      });
  };

  render() {
    const { showModal, onHideModal } = this.props;
    return (
      <Modal onClose={onHideModal} showModal={showModal}>
        <SetCodeWordForm
          onSubmit={this.handleSubmit}
          innerError={this.state.error}
          loading={this.state.loading}
        />
      </Modal>
    );
  }
}
